/**
 * Oracle Bridge URL Utility
 *
 * Single source of truth for resolving the oracle-bridge base URL — the UAT
 * portal backend (/api/uat/* endpoints). Reads VITE_ORACLE_BRIDGE_URL, falls
 * back to same-origin in production or localhost:3000 in development/test.
 */
export function getOracleBridgeUrl(): string {
  if (import.meta.env.VITE_ORACLE_BRIDGE_URL) {
    return import.meta.env.VITE_ORACLE_BRIDGE_URL;
  }
  if (import.meta.env.PROD) {
    return ''; // Same-origin in production
  }
  return 'http://localhost:3000';
}
